import { requestService } from '../helpers/request.service';

export const filesService = {
    getFile,
    downloadFile,
}

function getFile(params) {
    return requestService.get({
        methodName: '/Files/DownloadFile',
        queryString: params,
    });
}

function downloadFile(params) {
    return requestService.get({
        methodName: '/Files/DownloadFile',
        queryString: params,
        openBlankPage: true
    });
}
